import { Navigate } from 'react-router-dom';
import { useEffect } from 'react';

import usePageTitle from '../../hooks/usePageTitle';
import ManageServiceForm from './ManageServiceForm';
import { useAuth } from '../../AuthContext';
import { CONTAINER_CONTENT_CLASS } from '../signatures/Signatures';
import useLocalizedCopy from '../../hooks/useLocalizedCopy';
import { usePageHeader } from '../../contexts/PageHeaderContext';
import { useAxios } from '../../core/_axios';
import useAccount from '../../hooks/useAccount';
import { isPaymentOutOfDate, getAgencyName } from '../../utils/paymentUtils';
import LoadingSpinner from '../../components/LoadingSpinner';

export function CreateService() {

    const {
        copy
    } = useLocalizedCopy();
    const { setPageHeader } = usePageHeader();
    const axios = useAxios();

    usePageTitle(copy.CreateService.title);

    const {
        viewingAllAccounts,
        currentUser
    } = useAuth();

    const { account, loading: loadingAccount } = useAccount({
        axios,
        isForCurrentAccount: !viewingAllAccounts
    });

    useEffect(() => {
        setPageHeader(copy.CreateService.title);
        return () => setPageHeader(null);
    }, [copy.CreateService.title, setPageHeader]);

    if (viewingAllAccounts) {
        // We can only create a service when viewing a single account
        return <Navigate to="/" />;
    }

    // Show loading while checking account
    if (loadingAccount) {
        return <LoadingSpinner />;
    }

    // Block access if payment is out of date for user or account's agency
    const paymentOutOfDate = isPaymentOutOfDate(currentUser, account);

    if (paymentOutOfDate) {
        const agencyName = getAgencyName(currentUser, account);
        return (
            <div className="container-fixed">
                <div className="card">
                    <div className="card-body">
                        <div className="flex flex-col items-center justify-center py-12 text-center">
                            <i className="ki-filled ki-information-circle text-6xl text-red-600 mb-4"></i>
                            <h3 className="text-2xl font-semibold text-gray-900 mb-2">
                                Feature Restricted
                            </h3>
                            <p className="text-gray-600 mb-4 max-w-md">
                                Creating new services is currently restricted because payment for {agencyName} is past due.
                            </p>
                            <p className="text-sm text-gray-500">
                                Please contact your agency administrator or SGB support to resolve this issue.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container-fixed">
            <ManageServiceForm />
        </div>
    );
}